/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetEntityOpportunityInputJsonApiModel = {
  id: "",
  filters: {
    jsonApi: "hasOne",
    type: "entity-opportunity-filters",
  },
};
